import React from "react";

export default function HoliFrame4({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <clipPath id="clippath">
            <rect
              width={1576.58}
              height={1576.58}
              x={212.14}
              y={167.11}
              rx={66.57}
              ry={66.57}
              style={{
                fill: "none",
              }}
            />
          </clipPath>
          <style>
            {
              ".cls-4hol7{fill:#b54d1f}.cls-4hol15{fill:#fff}.cls-4hol25{fill:#a7dcf9}.cls-4hol32{fill:#fbdf07}.cls-4hol90{fill:#89cffd}.cls-4hol92{fill:#ff7f3f}.cls-4hol128{fill:#f94892}.cls-4hol130{fill:#ffe75c}.cls-4hol135{fill:#ff76b4}"
            }
          </style>
        </defs>
        <g
          style={{
            clipPath: "url(#clippath)",
          }}
        >
          <path
            d="M212.14 167.11h12.32v1576.58h-12.32z"
            className="cls-4hol92"
          />
          <path
            d="M224.45 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ff803f",
            }}
          />
          <path
            d="M236.77 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ff813e",
            }}
          />
          <path
            d="M249.09 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ff823e",
            }}
          />
          <path
            d="M261.41 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ff833d",
            }}
          />
          <path
            d="M273.72 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ff843d",
            }}
          />
          <path
            d="M286.04 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ff853c",
            }}
          />
          <path
            d="M298.36 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ff863c",
            }}
          />
          <path
            d="M310.67 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ff873b",
            }}
          />
          <path
            d="M322.99 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ff883b",
            }}
          />
          <path
            d="M335.31 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ff893a",
            }}
          />
          <path
            d="M347.63 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ff8a3a",
            }}
          />
          <path
            d="M359.94 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ff8b39",
            }}
          />
          <path
            d="M372.26 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ff8c39",
            }}
          />
          <path
            d="M384.58 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ff8d38",
            }}
          />
          <path
            d="M396.89 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ff8e38",
            }}
          />
          <path
            d="M409.21 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ff8f37",
            }}
          />
          <path
            d="M421.53 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ff9037",
            }}
          />
          <path
            d="M433.84 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ff9136",
            }}
          />
          <path
            d="M446.16 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ff9236",
            }}
          />
          <path
            d="M458.48 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ff9335",
            }}
          />
          <path
            d="M470.8 167.11h12.32v1576.58H470.8z"
            style={{
              fill: "#ff9435",
            }}
          />
          <path
            d="M483.11 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ff9534",
            }}
          />
          <path
            d="M495.43 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ff9634",
            }}
          />
          <path
            d="M507.75 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ff9733",
            }}
          />
          <path
            d="M520.06 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ff9833",
            }}
          />
          <path
            d="M532.38 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ff9932",
            }}
          />
          <path
            d="M544.7 167.11h12.32v1576.58H544.7z"
            style={{
              fill: "#ff9a32",
            }}
          />
          <path
            d="M557.02 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ff9b31",
            }}
          />
          <path
            d="M569.33 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ff9c31",
            }}
          />
          <path
            d="M581.65 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ff9d30",
            }}
          />
          <path
            d="M593.97 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ff9e30",
            }}
          />
          <path
            d="M606.28 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ff9f2f",
            }}
          />
          <path
            d="M618.6 167.11h12.32v1576.58H618.6z"
            style={{
              fill: "#ffa02f",
            }}
          />
          <path
            d="M630.92 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffa12e",
            }}
          />
          <path
            d="M643.23 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffa22e",
            }}
          />
          <path
            d="M655.55 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffa32d",
            }}
          />
          <path
            d="M667.87 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffa42d",
            }}
          />
          <path
            d="M680.19 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffa52c",
            }}
          />
          <path
            d="M692.5 167.11h12.32v1576.58H692.5z"
            style={{
              fill: "#ffa62c",
            }}
          />
          <path
            d="M704.82 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffa72b",
            }}
          />
          <path
            d="M717.14 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffa82b",
            }}
          />
          <path
            d="M729.45 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffa92a",
            }}
          />
          <path
            d="M741.77 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffaa2a",
            }}
          />
          <path
            d="M754.09 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffab29",
            }}
          />
          <path
            d="M766.41 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffac29",
            }}
          />
          <path
            d="M778.72 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffad28",
            }}
          />
          <path
            d="M791.04 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffae28",
            }}
          />
          <path
            d="M803.36 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffaf27",
            }}
          />
          <path
            d="M815.67 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffb027",
            }}
          />
          <path
            d="M827.99 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffb126",
            }}
          />
          <path
            d="M840.31 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffb226",
            }}
          />
          <path
            d="M852.62 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffb325",
            }}
          />
          <path
            d="M864.94 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffb425",
            }}
          />
          <path
            d="M877.26 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffb524",
            }}
          />
          <path
            d="M889.58 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffb624",
            }}
          />
          <path
            d="M901.89 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffb723",
            }}
          />
          <path
            d="M914.21 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffb823",
            }}
          />
          <path
            d="M926.53 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffb922",
            }}
          />
          <path
            d="M938.84 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffba22",
            }}
          />
          <path
            d="M951.16 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffbb21",
            }}
          />
          <path
            d="M963.48 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffbc21",
            }}
          />
          <path
            d="M975.8 167.11h12.32v1576.58H975.8z"
            style={{
              fill: "#ffbd20",
            }}
          />
          <path
            d="M988.11 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffbe20",
            }}
          />
          <path
            d="M1000.43 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffc01f",
            }}
          />
          <path
            d="M1012.75 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffc11f",
            }}
          />
          <path
            d="M1025.06 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffc21e",
            }}
          />
          <path
            d="M1037.38 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffc31e",
            }}
          />
          <path
            d="M1049.7 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffc41d",
            }}
          />
          <path
            d="M1062.01 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffc51d",
            }}
          />
          <path
            d="M1074.33 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffc61c",
            }}
          />
          <path
            d="M1086.65 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffc71c",
            }}
          />
          <path
            d="M1098.97 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffc81b",
            }}
          />
          <path
            d="M1111.28 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffc91b",
            }}
          />
          <path
            d="M1123.6 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffca1a",
            }}
          />
          <path
            d="M1135.92 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffcb1a",
            }}
          />
          <path
            d="M1148.23 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffcc19",
            }}
          />
          <path
            d="M1160.55 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffcd19",
            }}
          />
          <path
            d="M1172.87 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffce18",
            }}
          />
          <path
            d="M1185.19 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffcf18",
            }}
          />
          <path
            d="M1197.5 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffd017",
            }}
          />
          <path
            d="M1209.82 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffd117",
            }}
          />
          <path
            d="M1222.14 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffd216",
            }}
          />
          <path
            d="M1234.45 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffd316",
            }}
          />
          <path
            d="M1246.77 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffd415",
            }}
          />
          <path
            d="M1259.09 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffd515",
            }}
          />
          <path
            d="M1271.4 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffd614",
            }}
          />
          <path
            d="M1283.72 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffd714",
            }}
          />
          <path
            d="M1296.04 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffd813",
            }}
          />
          <path
            d="M1308.36 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffd913",
            }}
          />
          <path
            d="M1320.67 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffda12",
            }}
          />
          <path
            d="M1332.99 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffdb12",
            }}
          />
          <path
            d="M1345.31 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffdc11",
            }}
          />
          <path
            d="M1357.62 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#fd1",
            }}
          />
          <path
            d="M1369.94 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffde10",
            }}
          />
          <path
            d="M1382.26 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffdf10",
            }}
          />
          <path
            d="M1394.58 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffe00f",
            }}
          />
          <path
            d="M1406.89 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffe10f",
            }}
          />
          <path
            d="M1419.21 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffe20e",
            }}
          />
          <path
            d="M1431.53 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffe30e",
            }}
          />
          <path
            d="M1443.84 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffe40d",
            }}
          />
          <path
            d="M1456.16 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffe50d",
            }}
          />
          <path
            d="M1468.48 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffe60c",
            }}
          />
          <path
            d="M1480.79 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffe70c",
            }}
          />
          <path
            d="M1493.11 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffe80b",
            }}
          />
          <path
            d="M1505.43 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffe90b",
            }}
          />
          <path
            d="M1517.75 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffea0a",
            }}
          />
          <path
            d="M1530.06 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffeb0a",
            }}
          />
          <path
            d="M1542.38 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffec09",
            }}
          />
          <path
            d="M1554.7 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffed09",
            }}
          />
          <path
            d="M1567.01 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffee08",
            }}
          />
          <path
            d="M1579.33 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ffef08",
            }}
          />
          <path
            d="M1591.65 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#fff007",
            }}
          />
          <path
            d="M1603.97 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#fff107",
            }}
          />
          <path
            d="M1616.28 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#fff206",
            }}
          />
          <path
            d="M1628.6 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#fff306",
            }}
          />
          <path
            d="M1640.92 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#fff405",
            }}
          />
          <path
            d="M1653.23 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#fff505",
            }}
          />
          <path
            d="M1665.55 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#fff604",
            }}
          />
          <path
            d="M1677.87 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#fff704",
            }}
          />
          <path
            d="M1690.19 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#fff803",
            }}
          />
          <path
            d="M1702.5 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#fff903",
            }}
          />
          <path
            d="M1714.82 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#fffa02",
            }}
          />
          <path
            d="M1727.14 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#fffb02",
            }}
          />
          <path
            d="M1739.45 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#fffc01",
            }}
          />
          <path
            d="M1751.77 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#fffd01",
            }}
          />
          <path
            d="M1764.09 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#fffe00",
            }}
          />
          <path
            d="M1776.4 167.11h12.32v1576.58h-12.32z"
            style={{
              fill: "#ff0",
            }}
          />
        </g>
        <rect
          width={1185.31}
          height={1185.31}
          x={407.77}
          y={364.35}
          className="cls-4hol15"
          rx={66.57}
          ry={66.57}
        />
        <path
          d="M1076.78 404.33c-41.43-32.7-82.86-65.39-124.29-98.09a1754.865 1754.865 0 0 0 148.87-65.43c-8.2 54.51-16.39 109.02-24.59 163.53ZM1612 500.63c-20.01-48.84-40.01-97.68-60.02-146.51a1755.28 1755.28 0 0 0 161.81 16.19L1612 500.63Z"
          className="cls-4hol130"
        />
        <path
          d="M290.33 400.31c-9.84-66.16-19.68-132.33-29.53-198.49a6336.727 6336.727 0 0 0 209.8 85.25c-60.09 37.75-120.18 75.49-180.28 113.24Z"
          className="cls-4hol90"
        />
        <path
          d="M519.94 549.49c-33.24-44.59-66.49-89.18-99.73-133.77 33.49-2.99 67.51-6.35 102.03-10.12 28.8-3.14 57.2-6.48 85.19-9.99-29.16 51.29-58.32 102.59-87.49 153.88Z"
          className="cls-4hol25"
        />
        <path
          d="m1222.08 327.51-120.71-87.56a3488.806 3488.806 0 0 0 130.67-70.63c-3.32 52.73-6.64 105.46-9.97 158.19ZM1433.55 453.22c-5.75-49.37-11.51-98.75-17.26-148.12 24.88 9.17 50.29 18.2 76.2 27.07 21.63 7.4 43.05 14.5 64.24 21.3l-123.18 99.75Z"
          className="cls-4hol135"
        />
        <path
          d="m908.97 468.52-119.18-106.7c27.7-8.23 56.56-17.49 86.38-27.92 25.58-8.95 50.03-18.12 73.32-27.37l-40.53 162ZM1264.88 371.74l14.22-159.33a1888.1 1888.1 0 0 0 74.05 52.52c22.47 15.14 44.45 29.25 65.79 42.39-51.35 21.47-102.71 42.95-154.06 64.42Z"
          className="cls-4hol25"
        />
        <path
          d="M720.34 523.95 607.43 401.11c33.01-6.41 66.5-13.24 100.45-20.52 28.33-6.08 56.24-12.31 83.71-18.67-23.75 54.01-47.5 108.02-71.26 162.03Z"
          className="cls-4hol135"
        />
        <path
          d="M320.9 553.48c-28.8-46.89-57.6-93.78-86.41-140.67 32.12 1.59 65.82 2.61 100.98 2.84 30.15.2 59.19-.19 87.05-1.05-33.88 46.29-67.75 92.59-101.63 138.88Z"
          className="cls-4hol130"
        />
        <path
          d="m979.87 622.58-76.74-224.21a2262.69 2262.69 0 0 0 123.86 17.59c35.47 4.04 69.78 7.11 102.83 9.35L979.87 622.57Z"
          className="cls-4hol90"
        />
        <path
          d="M358.09 420.29c-47.08 0-94.21-1.99-141.29-5.97a3.25 3.25 0 1 1 .54-6.48c151.51 12.82 303.64 4.9 452.17-23.55 199.36-38.18 388.77-112.18 562.97-219.95l2.28-1.41 1.82 1.97c48.61 52.52 132.21 124.15 254.4 167.13 119.81 42.14 227.8 39.43 297.29 29.74 1.77-.25 3.42.99 3.67 2.77s-.99 3.42-2.77 3.67c-70.21 9.79-179.31 12.53-300.35-30.04-121.94-42.88-205.83-114.01-255.2-166.89C1059.37 278.7 870 352.51 670.73 390.68c-102.95 19.72-207.64 29.61-312.65 29.62Z"
          className="cls-4hol7"
        />
        <path
          d="m1685.35 600.92-140.02-191.19c39.44-5.3 80.68-11.9 123.48-20.08 35.07-6.7 68.74-13.99 100.95-21.69-28.14 77.65-56.28 155.3-84.42 232.96Z"
          className="cls-4hol90"
        />
        <path
          d="M505.39 520.16 468 286.15c37.13 13.04 75.7 25.84 115.68 38.24 34.36 10.65 68.01 20.47 100.89 29.52-59.73 55.41-119.46 110.83-179.18 166.24ZM1231.83 638.54c-34.51-71.11-69.01-142.22-103.52-213.33 38.45 2.16 79 3.36 121.47 3.25 36.95-.09 72.43-1.17 106.3-2.99-41.42 71.02-82.84 142.04-124.26 213.07Z"
          className="cls-4hol128"
        />
        <path
          d="m752.98 538.39-67.86-186.6c37.46 9.63 76.93 18.96 118.3 27.71 35.47 7.51 69.79 14.06 102.82 19.78-51.09 46.37-102.17 92.74-153.26 139.11ZM1456.42 586.45c-33.45-53.66-66.89-107.32-100.34-160.98a1563.766 1563.766 0 0 0 189.25-16.03c-29.64 59-59.28 118-88.91 177Z"
          className="cls-4hol32"
        />
        <path
          d="M1264.62 430.59c-172.73 0-346.56-19.92-518.75-59.55-166.26-38.26-332.03-95.17-492.71-169.15a3.248 3.248 0 1 1 2.72-5.9c382.78 176.23 776.66 251 1170.69 222.21 120.97-8.84 242.56-27.8 361.4-56.37 1.75-.42 3.5.66 3.92 2.4.42 1.75-.66 3.5-2.4 3.92-119.18 28.65-241.12 47.67-362.44 56.54-53.96 3.94-108.15 5.91-162.42 5.91Z"
          className="cls-4hol7"
        />
        <circle cx={502.48} cy={331.97} r={18.82} className="cls-4hol32" />
        <circle cx={571.19} cy={364.35} r={8.93} className="cls-4hol32" />
        <circle cx={523.02} cy={413.05} r={16.07} className="cls-4hol32" />
        <circle cx={624.04} cy={370.5} r={12.14} className="cls-4hol32" />
        <circle cx={583.63} cy={424.18} r={12.14} className="cls-4hol32" />
        <circle cx={519.82} cy={478.55} r={7.61} className="cls-4hol32" />
        <circle cx={962.06} cy={450.8} r={23.43} className="cls-4hol15" />
        <circle cx={1060.91} cy={459.9} r={14.81} className="cls-4hol15" />
        <circle cx={990.71} cy={560.92} r={14.81} className="cls-4hol15" />
        <circle cx={1456.18} cy={527.65} r={14.81} className="cls-4hol128" />
        <circle cx={1401.32} cy={448.96} r={14.81} className="cls-4hol128" />
        <circle cx={1504.26} cy={435.99} r={14.81} className="cls-4hol128" />
        <circle cx={1486.51} cy={487.02} r={7.77} className="cls-4hol128" />
        <circle cx={1447.86} cy={438.36} r={7.77} className="cls-4hol128" />
        <circle cx={1461.13} cy={467.86} r={4.96} className="cls-4hol128" />
        <circle cx={1419.43} cy={494.41} r={8.25} className="cls-4hol128" />
        <circle cx={1012.52} cy={495.78} r={12.64} className="cls-4hol15" />
        <path
          d="m270.1 1713.17-52.32-202.7c39.78 11.02 80.34 21.82 121.67 32.36 34.48 8.8 68.59 17.18 102.3 25.18L270.1 1713.17Z"
          className="cls-4hol32"
        />
        <path
          d="m1001.29 1837.07-106.56-212.82c40.65 1.71 83.34 2.46 127.89 1.94 36.5-.43 71.69-1.69 105.5-3.6-42.28 71.5-84.55 142.99-126.83 214.49Z"
          className="cls-4hol128"
        />
        <path
          d="m1714.09 1727.19-166.51-172.14c39.33-10.2 80.31-21.92 122.68-35.39 34.71-11.04 67.93-22.49 99.62-34.16-18.6 80.57-37.19 161.13-55.79 241.7ZM506.89 1794.9l-67.9-227.48a3411.8 3411.8 0 0 0 122.24 23.45c36.22 6.27 71.61 11.79 106.12 16.65-53.49 62.46-106.97 124.92-160.46 187.38ZM1258.89 1821.34c-44.11-66.23-88.22-132.45-132.33-198.68 39.28-2.68 80.57-6.57 123.63-11.99a2153.78 2153.78 0 0 0 107.44-16.29c-32.91 75.65-65.83 151.3-98.74 226.96Z"
          className="cls-4hol90"
        />
        <path
          d="m755.5 1820.76-88.14-213.33c39.23 4.85 80.48 8.97 123.62 12.05 36.99 2.65 72.7 4.34 107.01 5.26L755.5 1820.75Z"
          className="cls-4hol32"
        />
        <path
          d="M1480.03 1741.52c-40.8-49.05-81.6-98.09-122.39-147.14a1631.39 1631.39 0 0 0 189.91-39.61c-22.5 62.25-45.01 124.5-67.51 186.75Z"
          className="cls-4hol128"
        />
        <path
          d="M973.39 1628.79c-80.22 0-160.85-3.98-241.67-11.96-173.53-17.13-348.96-52.82-521.41-106.08a3.252 3.252 0 0 1-2.15-4.07 3.252 3.252 0 0 1 4.07-2.15c410.86 126.89 819.98 151.72 1215.99 73.79 121.57-23.92 242.48-57.98 359.37-101.22 1.68-.62 3.55.24 4.18 1.92.62 1.68-.24 3.55-1.92 4.18-117.21 43.36-238.46 77.51-360.37 101.5-149.2 29.36-301.86 44.09-456.08 44.09Z"
          className="cls-4hol7"
        />
        <ellipse
          cx={256.78}
          cy={1558.09}
          className="cls-4hol128"
          rx={16.2}
          ry={15.84}
        />
        <ellipse
          cx={316.4}
          cy={1575.35}
          className="cls-4hol128"
          rx={7.69}
          ry={7.52}
        />
        <ellipse
          cx={283.06}
          cy={1623.64}
          className="cls-4hol128"
          rx={13.83}
          ry={13.52}
        />
        <ellipse
          cx={362.19}
          cy={1574.91}
          className="cls-4hol128"
          rx={10.45}
          ry={10.22}
        />
        <ellipse
          cx={336.02}
          cy={1626.54}
          className="cls-4hol128"
          rx={10.45}
          ry={10.22}
        />
        <ellipse
          cx={284.86}
          cy={1676.14}
          className="cls-4hol128"
          rx={6.55}
          ry={6.41}
        />
        <ellipse
          cx={729.97}
          cy={1642.97}
          className="cls-4hol15"
          rx={16.04}
          ry={15.69}
        />
        <ellipse
          cx={772.35}
          cy={1751.81}
          className="cls-4hol15"
          rx={15.14}
          ry={14.81}
        />
        <ellipse
          cx={833.99}
          cy={1650.7}
          className="cls-4hol15"
          rx={15.14}
          ry={14.81}
        />
        <ellipse
          cx={1472.25}
          cy={1683.21}
          className="cls-4hol128"
          rx={15.14}
          ry={14.81}
        />
        <ellipse
          cx={1406.52}
          cy={1612.01}
          className="cls-4hol128"
          rx={15.14}
          ry={14.81}
        />
        <ellipse
          cx={1509.29}
          cy={1586.25}
          className="cls-4hol128"
          rx={15.14}
          ry={14.81}
        />
        <ellipse
          cx={1497.81}
          cy={1639.1}
          className="cls-4hol128"
          rx={7.94}
          ry={7.77}
        />
        <ellipse
          cx={1452.38}
          cy={1595.66}
          className="cls-4hol128"
          rx={7.94}
          ry={7.77}
        />
        <ellipse
          cx={1469.62}
          cy={1623.27}
          className="cls-4hol128"
          rx={5.07}
          ry={4.96}
        />
        <ellipse
          cx={1430.72}
          cy={1654.83}
          className="cls-4hol128"
          rx={8.44}
          ry={8.25}
        />
        <ellipse
          cx={787.49}
          cy={1681.16}
          className="cls-4hol15"
          rx={12.92}
          ry={12.64}
        />
        <ellipse
          cx={739.52}
          cy={1701.94}
          className="cls-4hol15"
          rx={11.9}
          ry={11.64}
        />
        <circle cx={1413.55} cy={1612.01} r={17.18} className="cls-4hol32" />
        <circle cx={1495.53} cy={1593.38} r={10.05} className="cls-4hol32" />
        <circle cx={1465.86} cy={1628.1} r={12.33} className="cls-4hol32" />
        <circle cx={1472.25} cy={1683.21} r={17.73} className="cls-4hol32" />
        {children}
      </g>
    </svg>
  );
}
